import { TextField, Button, Typography } from "@mui/material";
import { buttonPrimaryStyles } from "../../styles/ComponentStyles";
import StatusMessage from "./StatusMessage";

export default function ResetPasswordForm({
  translate,
  email,
  setEmail,
  isValidEmail,
  statusMessage,
  onSubmit,
  onBack,
}) {
  return (
    <form onSubmit={onSubmit} style={{ width: "100%", maxWidth: 350 }}>
      <TextField
        label={translate("email")}
        fullWidth
        margin="normal"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <Button
        type="submit"
        variant="contained"
        fullWidth
        disabled={!isValidEmail}
        sx={{ ...buttonPrimaryStyles, mt: 2 }}
      >
        {translate("send_reset_link")}
      </Button>

      <StatusMessage message={statusMessage} />

      <Typography
        sx={{ mt: 2, cursor: "pointer", textDecoration: "underline" }}
        onClick={onBack}
      >
        {translate("login")}
      </Typography>
    </form>
  );
}
